export const SEARCH_DUMMY_CHATS = [
    {
        _id: 'chat_001',
        customerName: 'Jacob Jones',
        customerAvatar: null,
        conversation: "Sure, that sounds good. I need to ...",
        assignedTo: 'Guy Hawkins',
        device: 'Android',
        lastUpdated: '2 hours ago',
    },
    {
        _id: 'chat_002',
        customerName: 'Sarah Chen',
        customerAvatar: null,
        conversation: "Not too bad, just trying to catch up ...",
        assignedTo: 'Kristin Watson',
        device: 'Android',
        lastUpdated: '2 hours ago',
    },
    {
        _id: 'chat_003',
        customerName: 'Wade Warren',
        customerAvatar: null,
        conversation: "I have a quick question about my order ...",
        assignedTo: 'Courtney Henry',
        device: 'iOS',
        lastUpdated: '3 hours ago',
    },
    {
        _id: 'chat_004',
        customerName: 'Esther Howard',
        customerAvatar: null,
        conversation: "Thanks for the update, sounds great!",
        assignedTo: 'Leslie Alexander',
        device: 'Web',
        lastUpdated: '5 hours ago',
    },
];

export const SEARCH_DUMMY_TICKETS = [
    {
        _id: 'ticket_70668',
        ticketNumber: '70668',
        subject: "Can't login my account ...",
        status: 'open',
        priority: 'urgent',
        assigneeName: 'Courtney Henry',
        customerName: 'Brooklyn Simmons',
        customerEmail: 'alma.lawson@example.com',
        updatedAt: '2023-08-16T13:00:00Z',
        tags: ['login', 'account'],
    },
    {
        _id: 'ticket_39635',
        ticketNumber: '39635',
        subject: 'Need blood samples urgent ...',
        status: 'solved',
        priority: 'high',
        assigneeName: 'Leslie Alexander',
        customerName: 'Bessie Cooper',
        customerEmail: 'debra.holt@example.com',
        updatedAt: '2018-04-04T12:00:00Z',
        tags: ['medical', 'urgent'],
    },
    {
        _id: 'ticket_43756',
        ticketNumber: '43756',
        subject: 'Find new property issue ...',
        status: 'pending',
        priority: 'medium',
        assigneeName: 'Kristin Watson',
        customerName: 'Annette Black',
        customerEmail: 'michelle.rivera@example.com',
        updatedAt: '2015-05-27T12:00:00Z',
        tags: ['property'],
    },
    {
        _id: 'ticket_28491',
        ticketNumber: '28491',
        subject: 'Payment not processed correctly',
        status: 'open',
        priority: 'high',
        assigneeName: 'Guy Hawkins',
        customerName: 'Devon Lane',
        customerEmail: 'devon.lane@example.com',
        updatedAt: '2024-01-10T09:30:00Z',
        tags: ['billing', 'payment'],
    },
    {
        _id: 'ticket_55102',
        ticketNumber: '55102',
        subject: 'Widget not loading on mobile',
        status: 'pending',
        priority: 'low',
        assigneeName: 'Courtney Henry',
        customerName: 'Savannah Nguyen',
        customerEmail: 'savannah.n@example.com',
        updatedAt: '2024-02-01T14:20:00Z',
        tags: ['mobile', 'widget'],
    },
];

export const SEARCH_DUMMY_KB_ARTICLES = [
    {
        _id: 'kb_001',
        title: 'Getting Started with TrustChat',
        status: 'Published',
        createdBy: 'Cody Fisher',
        category: 'Getting Started',
        visibility: 'Public',
        lastUpdated: '2 hours ago',
    },
    {
        _id: 'kb_002',
        title: 'API Authentication Guide',
        status: 'Published',
        createdBy: 'Michael Rodriguez',
        category: 'API Reference',
        visibility: 'Public',
        lastUpdated: '4 hours ago',
    },
    {
        _id: 'kb_003',
        title: 'Troubleshooting Connection Issues',
        status: 'Draft',
        createdBy: 'Emma Wilson',
        category: 'Troubleshooting',
        visibility: 'Internal',
        lastUpdated: '1 day ago',
    },
    {
        _id: 'kb_004',
        title: 'Advanced Webhook Configuration',
        status: 'Pending Review',
        createdBy: 'James Park',
        category: 'Developer Guide',
        visibility: 'Public',
        lastUpdated: '1 day ago',
    },
];

export const KB_STATUSES = ['published', 'draft', 'pendingReview', 'archived'];

export const SEARCH_FILTER_OPTIONS = {
    statuses: [
        { label: 'Open', id: 'open' },
        { label: 'Pending', id: 'pending' },
        { label: 'Solved', id: 'solved' },
        { label: 'Spam', id: 'spam' },
        { label: 'Published', id: 'published' },
        { label: 'Draft', id: 'draft' },
        { label: 'Pending Review', id: 'pendingReview' },
        { label: 'Archived (KB Only)', id: 'archived' },
    ],
    priorities: ['urgent', 'high', 'medium', 'low'],
    types: ['chat', 'ticket', 'article'],
    sortOptions: ['Relevance', 'Newest', 'Oldest', 'Recently Updated', 'Most Viewed'],
};

export const SEARCH_MORE_FILTER_OPTIONS = [
    'Contact',
    'Company',
    'Inbox',
    'Body',
    'Reply From',
    'Note From',
    'Number',
    'ID',
    'Email',
    'Attached',
];
